import "./TravelLog.module.css";
import WildlingsWestHeader from "@/reusable_sections/Header";
import TheAdventureArchives from "./sections/TheAdventureArchives";
import TerrainDiscoveryMap from "./sections/TerrainDiscoveryMap";
import ExpeditionFooter from "@/reusable_sections/Footer";
export default function TravelLogPage() {
  return <div>
      <WildlingsWestHeader />
      <TheAdventureArchives />
      <TerrainDiscoveryMap />
      <ExpeditionFooter />
    </div>;
}